<ng-template #callDetailsModal cdkPortalOutlet></ng-template>
<!-- Hang Tight Screen -->
<div
  class="hang-tight-screen"
  *ngIf="!resultReady && translationLoaded"
>
  <app-hang-tight
    [isErrorLoadingScreen]="isErrorLoadingScreen"
    [displayButtonLoadingScreen]="displayButtonLoadingScreen"
    [titleLoadingScreen]="titleLoadingScreen"
    [messageLoadingScreen]="messageLoadingScreen"
  >
  </app-hang-tight>
</div>

<div
  *ngIf="resultReady && translationLoaded"
  class="container"
>
  <!-- Objectives Modal -->
  <ng-template #modalObjectivesTemplate>
    <div class="custom-dialog-container">
      <div
        data-testId="conversationalResults"
        class="container-modal"
        appClickedOutside
        (clickedOutside)="closeModal()"
      >
        <div
          data-testId="conversationalResultsCloseButton"
          class="close-button"
          (click)="closeModal()"
        >
          <img src="assets\icons\x-close-button.svg" [alt]="'results.CLOSE_BUTTON' | transloco" />
        </div>
        <div
          data-testId="conversationalResultsObjective"
          class="objectives-info-modal-content"
          [innerHtml]="conversationalResults?.objectiveDescription"
        ></div>
      </div>
    </div>
  </ng-template>

  <div class="content">
    <!-- Top call title and date -->
    <div class="call-title-container">
      <div class="call-title-content">

        <qai-inner-wrap class="call-title-section">
          <div class="call-title">
            <div>
              <div>
                <div class="breadcrumbs" *ngIf="isResultPersonalizedPractice; else defaultBreadcrumbs">
                  <span [routerLink]="'/personalized-practice'" data-testId="assignments"
                    >Personalized practice</span
                  >
                  <img src="assets/icons/chavron-right-black.svg" />
                  <span
                    (click)="navigateToCurrentAssignment()"
                    data-testId="currentAssignment"
                  >
                    {{ assignment?.moduleAssignmentName }}
                  </span>
                </div>
                <ng-template #defaultBreadcrumbs>
                  <div class="breadcrumbs">
                    <span [routerLink]="'/assignment'" data-testId="assignments"
                      >{{'results.ASSIGNMENTS'| transloco}}</span
                    >
                    <img src="assets/icons/chavron-right-black.svg" />
                    <span
                      (click)="navigateToCurrentAssignment()"
                      data-testId="currentAssignment"
                    >
                      {{ assignment?.moduleAssignmentName }}
                    </span>
                  </div>
                </ng-template>
                <div
                  class="practice-session-date"
                  *ngIf="isResultPersonalizedPractice && formattedScoredAt"
                >
                  {{ formattedScoredAt }}
                </div>
                <div
                  class="practice-session-metadata"
                  *ngIf="isResultPersonalizedPractice && conversationalResults"
                >
                  <div class="metadata-item">
                    <label class="metadata-label">Conversation type:</label>
                    <qai-badge [shape]="'round'" [kind]="'gray'" [label]="conversationalResults.callName"></qai-badge>
                  </div>
                  <div class="metadata-item">
                    <label class="metadata-label">Difficulty:</label>
                    <qai-badge [shape]="'round'" [kind]="'gray'" [label]="conversationalResults.customizations?.difficulty?.displayText || 'Difficulty'"></qai-badge>
                  </div>
                  <div class="metadata-item">
                    <label class="metadata-label">Mood:</label>
                    <qai-badge [shape]="'round'" [kind]="'gray'" [label]="conversationalResults.customizations?.temperament?.displayText || 'Temperament'"></qai-badge>
                  </div>
                  <a qai-link class="practice-again-link" (click)="onPersonalizedPracticePracticeAgainClick($event)">
                    <qai-icon kind="repeat" qaiSlot="start" />
                    <span class="practice-again-text">Practice again</span>
                  </a>
                </div>
                <div class="call-name" *ngIf="!isResultPersonalizedPractice">
                  <h1 data-testId="callTitle">
                    {{ conversationalResults!.callName }}
                  </h1>
                  <span
                    *ngIf="call?.hasDetails"
                    data-testId="viewCallDetails"
                    (click)="getCallDetails(call)"
                  >
                    {{'results.VIEW_CALL_DETAILS'| transloco}}
                  </span>
                </div>
              </div>
            </div>
            <div class="date" *ngIf="conversationalResults!.practiceCall && !isResultPersonalizedPractice">
              <qai-label
                [weight]="'bold'"
                [size]="'small'"
                data-testId="practiceSessions"
                >{{'results.PRACTICE_SESSION'| transloco}}</qai-label
              >
              <mat-select
                data-testId="practiceCallTimes"
                id="practiceCallTimes"
                hasBackdrop="true"
                [value]="practiceCallUuid"
                (selectionChange)="onSelectedPracticeTime($event)"
              >
                <mat-option
                  *ngFor="let call of practiceCallResults; let i = index"
                  [value]="call.practiceCallUuid"
                  [attr.data-testId]="'practiceCallTime-' + i"
                >

                  <qai-label [size]="'small'">
                    {{ call.attemptDate }}
                  </qai-label>
                </mat-option>
              </mat-select>
            </div>
          </div>
          <p *ngIf="showLegalDisclaimer && disclaimerText" class="header-legal-disclaimer">
            {{ disclaimerText }}
          </p>
        </qai-inner-wrap>

        <qai-tabs #tabs [attr.data-testid]="'qai-tabs'">
          <ng-template qaiTab="SCORE_OVERALL" [label]="'results.OVERALL_SCORE'| transloco">

            <div>
              <div class="header">
                <qai-inner-wrap class="header-content" [ngClass]="!isUserCompliant ? 'out-of-compliance' : ''">
                  <div class="header-content-title">
                      <ng-container *ngIf="isUserCompliant">
                        <h2 class="title" data-testId="overallResultTitle">
                          {{ getDynamicTextForOverallScore().h1 }}
                        </h2>
                        <p
                          class="sub-title"
                          data-testId="overallResultSubTitle"
                          [innerHTML]="getDynamicTextForOverallScore().h2"
                        ></p>
                      </ng-container>
                      <ng-container *ngIf="!isUserCompliant && isMaxAttemptsReached">
                        <span class="title">{{'results.YOU_ARE_OUT_OF_ATTEMPTS' | transloco}}</span>
                        <span class="title-normal"> {{'results.REVIEW_GUIDELINES_REMAIN_COMPLIANT' | transloco}}</span>
                      </ng-container>
                      <ng-container *ngIf="!isUserCompliant && !isMaxAttemptsReached">
                        <span class="title">{{'results.TRY_AGAIN_ATTENTION_TO_COMPLIANCE' | transloco}}</span><br>
                      </ng-container>
                      <button
                        *ngIf="!isUserCompliant && !isMaxAttemptsReached"
                        class="out-of-compliance-button"
                        qai-button
                        [kind]="'primary'"
                        [size]="'large'"
                        (click)="navigateToRoute()"
                      >
                        {{'results.TRY_AGAIN' | transloco}}
                      </button>
                  </div>

                  <div
                    *ngIf="isUserCompliant"
                    [ngClass]="
                      conversationalResults?.callScoreCalcType === 'AVG'
                        ? 'score-card-single'
                        : 'score-card-multi'
                    "
                  >
                    <qai-scores-list class="scores-list">
                      <qai-score
                        *ngFor="let score of scoresArray"
                        [direction]="'column'"
                        [size]="
                          score.label === 'Overall score' ? 'large' : 'medium'
                        "
                        [kind]="score.kind"
                        [value]="(score.value | number : '1.1-2') || ''"
                        [max]="score.max"
                        [label]="'results.OUT_OF' | transloco"
                        [description]="score.description"
                        [attr.data-testId]="score.label + 'ScoreCard'"
                      >
                        <div
                          qai-card-title
                          qaiSlot="title"
                          data-testId="overallScoreCardTitle"
                          *ngIf="score.label === 'Overall score'"
                        >
                          {{ ('results.' + score.labelKey) | transloco }}
                        </div>

                        <button
                          qai-card-title
                          qaiSlot="title"
                          [attr.data-testId]="score.label + 'CardTitle'"
                          (click)="cardClicked(score.label)"
                          *ngIf="score.label !== 'Overall score'"
                        >
                           {{ ('results.' + score.labelKey) | transloco }}
                        </button>

                        <button
                          *ngIf="score.label === 'Overall score' && conversationalResults?.callScoreCalcType === 'WEIGHTAVG'"
                          qai-link
                          qaiSlot="link"
                          data-testId="trackOverallScoreCalculations"
                          (click)="
                            handleOnClickHowIsCalculated(
                              amplitudeTrackingEventHowIsCalculated
                            )
                          "
                        >
                          {{'results.SCORE_CALCULATION_QUESTION'| transloco}}
                        </button>
                      </qai-score>
                    </qai-scores-list>

                    <dialog
                      #dialog
                      qai-dialog
                      [heading]="'results.SCORE_CALCULATION_TITLE' | transloco"
                      data-testId="scoreCalculationDialog"
                    >
                      {{'results.OVERALL_SCORE_EXPLANATION'| transloco}}
                      <br /><br />
                      {{'results.SCORE_CONFIG_NOTE'| transloco}}
                    </dialog>
                  </div>
                  <div *ngIf="!isUserCompliant" class="score-card-single">
                    <qai-overall-score
                      kind="non-compliant"
                      [heading]="'results.YOUR_SCORE' | transloco"
                      [score]="'results.OUT_OF_COMPLIANCE' | transloco"
                    />
                  </div>
                </qai-inner-wrap>
              </div>

              <qai-inner-wrap *ngIf="isUserCompliant" class="call-feedback-content">
                <div class="call-feedback-header">
                  <h2 data-testId="callFeedbackTitle">{{'results.CALL_FEEDBACK'| transloco}}</h2>
                </div>

                <qai-item-grid
                  gap="24px"
                  minItemWidth="280px"
                  repeatCount="auto-fit"
                  style="margin-bottom: 20px"
                >
                  <qai-result-card
                    [title]="scoreOverall?.Strengths?.title || ('results.STRENGTHS'| transloco)"
                    *ngIf="scoreOverall?.Strengths?.feedback"
                    [attr.data-testId]="'strengthsFeedbackCard'"
                  >
                    <qai-glyph kind="person" qaiSlot="icon" />
                    <ul *ngIf="scoreOverall?.Strengths">
                      <li
                        *ngFor="
                          let strengths of scoreOverall?.Strengths?.feedback;
                          let i = index
                        "
                        [attr.data-testid]="'strength-' + i"
                      >
                        <ng-container *ngIf="strengths | extractBold as parsed">
                          <b>{{ parsed?.boldText }}</b>
                          {{ parsed?.restText }}
                        </ng-container>
                      </li>
                    </ul>
                  </qai-result-card>

                  <qai-result-card
                    [title]="scoreOverall?.Opportunities?.title || ('results.OPPORTUNITIES'| transloco)"
                    [attr.data-testId]="'opportunitiesFeedbackCard'"
                  >
                    <qai-glyph kind="mountains" qaiSlot="icon" />
                    <ul *ngIf="scoreOverall?.Opportunities">
                      <li
                        *ngFor="
                          let opportunities of scoreOverall?.Opportunities
                            ?.feedback;
                          let i = index
                        "
                        [attr.data-testid]="'opportunities-' + i"
                      >
                        <ng-container
                          *ngIf="opportunities | extractBold as parsed"
                        >
                          <b>{{ parsed?.boldText }}</b>
                          {{ parsed?.restText }}
                        </ng-container>
                      </li>
                    </ul>
                  </qai-result-card>
                </qai-item-grid>
              </qai-inner-wrap>

              <div class="feedback-out-of-compliance-container">
                <!-- Feedback for non compliant Content -->
                <div *ngIf="!isUserCompliant" class="feedback-out-of-compliance">
                  <qai-inner-wrap class="content">
                    <!-- Answers feedback -->
                    <div class="questions">
                      <div class="question-result">
                        <div class="question out-of-compliance">{{'results.NO_SCORE_OUT_OF_COMPLIANCE' | transloco}}</div>

                        <div class="talking-points">
                          <!-- Missed -->
                          <div class="talking-point">
                            <div class="talking-point-title">{{'results.WHY_OUT_OF_COMPLIANCE' | transloco}}</div>
                            <div class="talking-point-subtitle">{{'results.REVIEW_MISSED_GUIDELINES' | transloco}}</div>
                            <div class="points">
                              <!-- Points list -->
                              <div class="points-list">
                                <ng-container *ngFor="let section of complianceScoringResult?.sections">
                                  <ng-container *ngFor="let fact of section.facts">
                                    <div class="point" *ngIf="fact.correct === 0">
                                      <img src="assets/icons/exclamation-red.svg" [alt]="'results.X_ICON_ALT' | transloco" />
                                      <div> {{fact.factText || fact.messageText}} </div>
                                    </div>
                                  </ng-container>
                                </ng-container>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </qai-inner-wrap>
                </div>


                <!-- Feedback for non compliant Content -->
                <div *ngIf="complianceScoringResult && anyCorrectFact" class="feedback-out-of-compliance">
                  <qai-inner-wrap class="content">

                    <!-- Answers feedback -->
                    <div class="questions">
                      <div class="question-result">
                        <div class="question compliance-followed">
                          <div class="question-name-thumbnail">
                            <span>{{'results.COMPLIANCE_GUIDELINES' | transloco}}</span>
                          </div>
                          <div class="point-collapser">
                            <img
                              (click)="isExpandedd = !isExpandedd" [src]="isExpandedd ? 'assets/icons/arrow/chevron-down-blue1.svg' : 'assets/icons/arrow/chevron-left-blue.svg'">
                          </div>
                        </div>

                        <div class="talking-points" *ngIf="isExpandedd">
                          <!-- Covered -->
                          <div class="talking-point">
                            <div class="talking-point-title">{{'results.WHAT_YOU_DID_WELL' | transloco}}</div>
                            <div class="talking-point-subtitle">{{'results.YOU_DID_FOLLOW_GUIDELINES' | transloco}}</div>
                            <div class="points">
                              <!-- Points list -->
                              <div class="points-list">
                                <ng-container *ngFor="let section of complianceScoringResult.sections">
                                  <ng-container *ngFor="let fact of section.facts">
                                    <div class="point" *ngIf="fact.correct === 1">
                                      <img src="/assets/icons/check-2.svg" alt="checkmark" />
                                      <div> {{fact.factText || fact.messageText}} </div>
                                    </div>
                                  </ng-container>
                                </ng-container>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </qai-inner-wrap>
                </div>
              </div>

              <div class="session-id">
                <div
                  class="text"
                  (click)="copyText()"
                  [matMenuTriggerFor]="tooltipMenu"
                  data-testId="sessionId"
                >
                  {{'results.SESSION_ID' | transloco}} {{ practiceCallUuid }}
                </div>
              </div>
              <mat-menu
                #tooltipMenu="matMenu"
                yPosition="above"
                hasBackdrop="false"
                class="tooltip-copy-session-id"
              >
                <div>{{'results.SESSION_ID_COPIED' | transloco}}</div>
              </mat-menu>
            </div>
          </ng-template>

          <!-- Hide if not compliant -->
          <ng-container *ngIf="isUserCompliant">
            <ng-template
              qaiTab="MESSAGE_ADHERENCE"
              label="{{'results.MESSAGE_ADHERENCE' | transloco}}"
              *ngIf="conversationalResults?.promptTypes?.includes(promptTypesKeyMapping.MESSAGE_ADHERENCE) || conversationalResults?.promptTypes?.includes(promptTypesKeyMapping.MESSAGE_ADHERENCE_V2)"

            >
              <app-new-message-adherence
                [practiceCallUuid]="practiceCallUuid"
                [messageAdherences]="scoreMessageAdherence"
                [messageAdherencesV2]="flattenedSections"
                [isMessageAdherenceV2]="isMessageAdherenceV2PromptType"
                [showMissedFacts]="showMissedFacts"
                [weightAverage]="weightAverage?.messageAdherence"
                [scoreCriteria]="criteriaScore"
                [scoreOverall]="scoreOverall"
                [scoredAt]="conversationalResults?.practiceCall?.scoredAt || ''"
                [callType]="conversationalResults?.callType"
                [remainingAttempts]="remainingAttempts"
                [isMaxAttemptsReached]="isMaxAttemptsReached"
                [practiceType]="conversationalResults?.practiceCall?.practiceType"
                [weightageCalculation]="conversationalResults?.callScoreCalcType === 'WEIGHTAVG'"
                [assignmentStatus]="assignment?.status"
                (callBtnClicked)="navigateToRoute()"
              ></app-new-message-adherence>
            </ng-template>

            <ng-template
              qaiTab="SCORE_CUSTOMIZED"
              label="{{'results.OBJECTIVES' | transloco}}"
              *ngIf="conversationalResults?.promptTypes?.includes(promptTypesKeyMapping.SCORE_CUSTOMIZED)"
            >
              <app-new-objectives
                [practiceCallUuid]="practiceCallUuid"
                [scoredAt]="conversationalResults?.practiceCall?.scoredAt || ''"
                [scoreOverall]="scoreOverall"
                [remainingAttempts]="remainingAttempts"
                [isMaxAttemptsReached]="isMaxAttemptsReached"
                [callType]="conversationalResults?.callType"
                [practiceType]="conversationalResults?.practiceCall?.practiceType"
                [objectives]="objectives"
                [weightAverage]="weightAverage?.scoreCustomized"
                [scoreCriteria]="criteriaScore"
                [scoreOverall]="scoreOverall"
                [assignmentStatus]="assignment?.status"
                (callBtnClicked)="navigateToRoute()"
              ></app-new-objectives>
            </ng-template>

            <ng-template
              qaiTab="SCORE_SKILLS"
              label="{{'results.SKILLS' | transloco}}"
              *ngIf="conversationalResults?.promptTypes?.includes(promptTypesKeyMapping.SCORE_SKILLS)"
            >
              <app-results-skills-new
                [practiceCallUuid]="practiceCallUuid"
                [weightageCalculation]="conversationalResults?.callScoreCalcType === 'WEIGHTAVG'"
                [scoredAt]="conversationalResults?.practiceCall?.scoredAt || ''"
                [scoreOverall]="scoreOverall"
                [scoreCriteria]="criteriaScore"
                [skillWeight]="weightAverage?.scoreSkills?.weight"
                [skillScore]="weightAverage?.scoreSkills?.average"
                [remainingAttempts]="remainingAttempts"
                [isMaxAttemptsReached]="isMaxAttemptsReached"
                [callType]="conversationalResults?.callType"
                [practiceType]="practiceType"
                [assignmentStatus]="assignment?.status"
                (callBtnClicked)="navigateToRoute()"
              ></app-results-skills-new>
            </ng-template>

            <ng-template
              *ngIf="transcriptTab"
              qaiTab="uniqueId5-5"
              [label]="transcriptLabel"
              (click)="trackTranscriptView()"
            >
              <app-results-transcript
                [practiceCallUuid]="practiceCallUuid"
                [transcriptTab]="transcriptTab"
                [userName]="userName"
                [agentName]="agentName"
                [callType]="conversationalResults?.callType"
                [practiceType]="conversationalResults?.practiceCall?.practiceType"
              >
              </app-results-transcript>
            </ng-template>
          </ng-container>

        </qai-tabs>
      </div>
    </div>

    <app-footer></app-footer>
  </div>
</div>
